export enum WidgetErrorTypeEnum {
  Content = 'content',
  Engine = 'engine',
  Auth = 'auth'
}
